import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../store';

const portalTypeSelector = createSelector([(state: RootState) => state.portal.portalType], (portalType) => portalType);

export { portalTypeSelector };
